/**
 * in this module you can find all the code related with OpenLayer 4, layers, maps and getSettings
 */

/**
 * import modules
 */
import Cookies from './cookies'
import overlay from './overlay'
import functions from './functions'
import print from './print'
import Map from 'ol/Map'
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import TileWMS from 'ol/source/TileWMS'
import TileGrid from 'ol/tilegrid/TileGrid'
import WMTSCapabilities from 'ol/format/WMTSCapabilities'
import WMTS, {optionsFromCapabilities} from 'ol/source/WMTS'
import Projection from 'ol/proj/Projection'
import proj4 from 'proj4'
import {register} from 'ol/proj/proj4'
import {createStringXY} from 'ol/coordinate'
import MousePosition from 'ol/control/MousePosition'
import OverviewMap from 'ol/control/OverviewMap'
import ScaleLine from 'ol/control/ScaleLine'
import {
  DragRotateAndZoom, MouseWheelZoom,PinchZoom,
  defaults as defaultInteractions,
} from 'ol/interaction';
import {defaults as defaultControls} from 'ol/control'
var pageconfig = JSON.parse($('#pageconfig').val())

/**
 * global var to reuse for export
 */
proj4.defs(
  'EPSG:27700',
  '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 ' +
    '+x_0=400000 +y_0=-100000 +ellps=airy ' +
    '+towgs84=446.448,-125.157,542.06,0.15,0.247,0.842,-20.489 ' +
    '+units=m +no_defs'
)
register(proj4)

/**
 * Zoomstack Layer to MM Layer
 */
function getMMLayer(ZoomstackLayer) {
  let mmLayertoUse = ''
  switch (ZoomstackLayer) {
    case 'Zoomstack:Zoomstack Road Style':
      mmLayertoUse = 'mastermap:mm-standard'
      break
    case 'Zoomstack:Zoomstack Deuteranopia Style':
      mmLayertoUse = 'mastermap:mm-bw'
      break
    case 'Zoomstack:Zoomstack Outdoor Style':
      mmLayertoUse = 'mastermap:mm-outdoor'
      break
    case 'Zoomstack:Zoomstack Light Style':
      mmLayertoUse = 'mastermap:mm-light'
      break
    case 'Zoomstack:Zoomstack Dark Style':
      mmLayertoUse = 'mastermap:mm-dark'
      break
    case 'Zoomstack:Zoomstack Tritanopia Style':
      mmLayertoUse = 'mastermap:mm-backdrop'
      break
    default:
      mmLayertoUse = 'mastermap:mm-standard'
      break
    }
    return mmLayertoUse
}

/**
 * Set BG color of viewport from layer
 */
function setViewPortColour(ZoomstackLayer) {
    let colourToUse = '#FFFFFF'
    switch (ZoomstackLayer) {
      case 'Zoomstack:Zoomstack Road Style':
        colourToUse = tenant === 'iom' ? '#BEFFFF' :  '#ffffcc'
        break
      case 'Zoomstack:Zoomstack Deuteranopia Style':
        colourToUse = tenant === 'iom' ? '#F1F1F1' :  '#ffffff'
        break
      case 'Zoomstack:Zoomstack Outdoor Style':
        colourToUse = tenant === 'iom' ? '#F8FFFF' :  '#e4efda'
        break
      case 'Zoomstack:Zoomstack Light Style': 
        colourToUse = tenant === 'iom' ? '#EFFFFF' :  '#efece8'
        break
      case 'Zoomstack:Zoomstack Dark Style':
      case 'mm-dark':  
        colourToUse = tenant === 'iom' ? '#000C0C' :  '#162639'
        break
      case 'Zoomstack:Zoomstack Tritanopia Style': 
        colourToUse = tenant === 'iom' ? '#EAFFFF' :  '#faf9f7'
        break
      case 'mastermap:mm-IoM_Overview':
        colourToUse = '#BEFFFF'
          break
      default:
        colourToUse = tenant === 'iom' ? '#BEFFFF' :  '#ffffcc'
        break
      }
      $('.ol-viewport').css('background-color',colourToUse)
  }
/**
 * global var to reuse for export
 */

let map
const resolutions = []
const tenant = $('#tenant').val()
let layerClass = 'baselayer'
/**
 * openlayers mapInit
 */

const mapInit = () => {

  /**
   * Get Settings stored in Cookies
   * 0 - Easting
   * 1 - Northing
   * 2 - Zoom
   * 3 - Cache Layer
   * 4 - Overview Layer
   */
  var CookieSettings = Cookies.getUserPrefs()
  CookieSettings = CookieSettings == null ? null : CookieSettings.split(',')

  /**
   * get the resolutions from the scales
   */

  // temp scale array
  const scaleArray = []
  // scales array
  const scales = pageconfig.scales.split(',')
  // create a temporary array of scales in number
  functions.getScale(scales, scaleArray)
  // create the final resolutions array
  functions.setResolution(scaleArray, resolutions)

  // center of the map when session storage position is not set
  const setPos = CookieSettings == null ? pageconfig.defpos.split(',') : CookieSettings

  // extent of the visible map
  const setExt = pageconfig.bounds.split(',')
  const ext = [parseInt(setExt[0]), parseInt(setExt[1]), parseInt(setExt[2]), parseInt(setExt[3])]
  let minZoom = pageconfig.minzoom
  /**
   * PROJECTION
   */

  const projection = new Projection({
    code: 'EPSG:27700',
    getPointResolution: (r) => {
      return r
    },
    units: 'm'
  })

  /**
   * map layers
   */

  /**
   * mapcache layer
   * urls below are for testing mapcahce
   */
  var cachelayer
  let ovlayer = pageconfig.ovlayer
  let ovUrl = pageconfig.ovmap
  var ovlayerToUse = (CookieSettings == null ||  CookieSettings[3] == 'Zoomstack:undefined') ? pageconfig.ovlayer : CookieSettings[3]
  let capXml = functions.getCacheCapabilities()

  if (ovlayerToUse.indexOf('mastermap:mm') !== -1) {
    capXml = functions.getMMCacheCapabilities()
  }

  if (capXml === 'error') {
    // failover
    ovlayerToUse = 'miniscale'
    ovUrl = functions.getFailoverUrl()
  } else {
    // WMTS OK so no need for url
    ovUrl = ''
  }

     /**
    * Set viewpoer color to match map
    */
   let viewPortTheme = ovlayerToUse
  if (tenant == 'iom') {
    //iom uses mastermap as its cach/ov layer so get capabilities from there
    capXml = functions.getMMCacheCapabilities()
    layerClass = getIomLayerCSS(ovlayerToUse)
    ovlayerToUse = 'mastermap:mm-IoM_Overview'
  }

  if (ovlayerToUse.indexOf('Zoomstack:Zoomstack') === -1 && ovlayerToUse.indexOf('mastermap:mm') === -1) {
    //  url: 'https://6fc6cff.online-server.cloud/mapcache/?',
    //  url: 'https://www.buchananmapping.co.uk/mapcache/?',
    //   url: 'https://d0bfa2f.online-server.cloud/mapcache/?',
    // https://www.buchananmapping.co.uk/mapcache/?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=true&LAYERS=Zoomstack%3Aundefined&TILED=true&WIDTH=256&HEIGHT=256&CRS=EPSG%3A27700&STYLES=&BBOX=218978%2C483441%2C222562%2C487025
    cachelayer = new TileLayer({
        // this extent limit the visible map
        extent: ext,
        minResolution: resolutions[minZoom],
        // Load low-resolution tiles up to preload levels. By default preload is 0, which means no preloading
        preload: Infinity,
        source: new TileWMS({
            url: ovUrl,
            params: {
            'LAYERS': ovlayerToUse,
            'TILED': true
            },
            ratio: 1,
            projection: 'EPSG:27700',
            tileGrid: new TileGrid({
            resolutions: resolutions,
            extent: ext,
            tileSize: [256, 256]
            })
        // resolutions doesn't work in the layer, has to stay in the view
        })
        })
  }
  else {

    var parser = new WMTSCapabilities()
    var result = parser.read(capXml)
    var options = optionsFromCapabilities(result, {
    layer: ovlayerToUse,
    matrixSet: 'BC27700',
    format: 'image/png8',
    })

    var source = new WMTS(options)
    cachelayer = new TileLayer({className: layerClass, id: 'ovlayer', extent: ext, source: source,resolutions: resolutions, minResolution: resolutions[minZoom],preload: Infinity})
  }

/**
 * mastermap and copyright layer
 */
let maplayer = pageconfig.wmslayer
let mmUrl = pageconfig.ovmap
let copylayer
var mapLayerToUse = (CookieSettings == null ||  CookieSettings[3] == 'Zoomstack:undefined') ? pageconfig.wmslayer : CookieSettings[3]
if (mapLayerToUse.indexOf("Zoomstack:Zoomstack") !== -1) {
    mapLayerToUse = tenant === 'iom' ? 'mastermap:mm-IoM' : getMMLayer(mapLayerToUse);
}
let mmcapXml = functions.getMMCacheCapabilities()
if (mmcapXml === 'error') {
    // failover
    mapLayerToUse = 'miniscale'
    mmUrl = functions.getFailoverUrl()
  } else {
    // WMTS OK so no need for url
    mmUrl = ''
  }

if (mapLayerToUse.indexOf('mastermap:mm') === -1) {
   /**
   * copyright layer
   */

   copylayer = new TileLayer({
    className: 'baselayer',
    id: 'copylayer',
    // this extent limit the visible map
    extent: ext,
    // Load low-resolution tiles up to preload levels. By default preload is 0, which means no preloading
    preload: Infinity,
    source: new TileWMS({
      url: 'https://www.buchananmapping.co.uk/cgi-bin/wms_bccopy?&amp;service=WMS',
      params: {
        'LAYERS': 'copyright',
        'TILED': true
      },
      ratio: 1,
      gutter: 40,
      projection: projection,
      tileGrid: new TileGrid({
        resolutions: resolutions,
        extent: ext,
        tileSize: [280, 280]
      })
    // resolutions doesn't work in the layer, has to stay in the view
    })
  })

  maplayer = new TileLayer({
    className: layerClass,
    id: 'maplayer',
    // this extent limit the visible map
    extent: ext,
    maxResolution: resolutions[minZoom-1],
    // Load low-resolution tiles up to preload levels. By default preload is 0, which means no preloading
    preload: Infinity,
    source: new TileWMS({
      url: mmUrl,
      params: {
        // the layers is a random layer in the map that we need to call in order to load the map
        'LAYERS': mapLayerToUse,
        'TILED': true
      },
      ratio: 1,
      projection: projection,
      tileGrid: new TileGrid({
        resolutions: resolutions,
        extent: ext,
        tileSize: [128, 128]
      })
    })
  })
} else {

    var parser = new WMTSCapabilities()
    var mmresult = parser.read(mmcapXml)
    var mmoptions = optionsFromCapabilities(mmresult, {
      layer: mapLayerToUse,
      matrixSet: 'BC27700'
    })
    var copyOptions = optionsFromCapabilities(mmresult, {
      layer: 'mastermap:bc-watermark',
      matrixSet: 'BC27700'
    })
    var mmsource = new WMTS(mmoptions)
    var copysource = new WMTS(copyOptions)

    maplayer = new TileLayer({className: layerClass, id: 'maplayer', extent: ext, source: mmsource, resolutions: resolutions, maxResolution: resolutions[minZoom-1],preload: Infinity})
    copylayer = new TileLayer({className: 'baselayer', id: 'copylayer', extent: ext, source: copysource, resolutions: resolutions, maxResolution: resolutions[minZoom-1], preload: Infinity})
}


  /**
   * overview map layer
   */
   if (ovlayerToUse.indexOf('Zoomstack:Zoomstack') === -1 && ovlayerToUse.indexOf('mastermap:mm') === -1) {
     ovlayer = new TileLayer({
       source: new TileWMS({
         url: ovUrl,
         params: {
           'LAYERS': ovlayerToUse,
           'TILED': true
         },
         ratio: 1,
         projection: 'EPSG:27700'
       // resolutions doesn't work in the layer, has to stay in the view
       })
     })
   }
   else {
     ovlayer = new TileLayer({className: layerClass,source: source})
   }


  /**
   * mouse coordinate on the screen
   */

  // this code has to stay before the creation of the map
  const mousePositionControl = new MousePosition({
      // the number pass as a parameter is the precision of the coordinates (the numbers before the comma, max 12 )
      coordinateFormat: createStringXY(1),
      projection: projection,
      // custom target
      target: document.getElementById('mapcoords'),
      // blank value when the mouse pointer is outside of the map
      undefinedHTML: '000000.0, 000000.0'
  })

  /**
   * overview map creation
   */

  const zoomLv = CookieSettings == null ? parseInt(pageconfig.defpos.split(',')[2]) : parseInt(CookieSettings[2])

  let overviewMapControl = new OverviewMap({
    className: 'ol-overviewmap ol-custom-overviewmap',
    layers: [ovlayer],
    view: new View({
      projection: projection
    }),
    collapseLabel: '\u00BB',
    label: '\u00AB',
    collapsed: false,
    // custom target
    target: document.getElementById('ovmap')
  })

  /**
   * map view
   */

  const view = new View({
    projection: projection,
    center: [parseInt(setPos[0]), parseInt(setPos[1])],
    // this extent limit the max accessible area, but it's not the same as the layer extent, is bigger
    extent: ext,
    resolution: resolutions[zoomLv],
    resolutions: resolutions,
    showFullExtent: true,
  })

  if (pageconfig.appname.type === 'psa' && !pageconfig.private) {
    map = new Map({
      interactions: defaultInteractions({
        altShiftDragRotate: false,
        shiftDragZoom: false,
        mouseWheelZoom: false,
        pinchZoom: false
      }).extend([
        //  drag for overview map
        new DragRotateAndZoom(),
        // mobile function to force constrainResolution
        new PinchZoom({
          // force zooming to a integer zoom
          constrainResolution: true
        }),
        // mouseWheel function to force constrainResolution
        new MouseWheelZoom({
          constrainResolution: true
        })
      ]),

      /**
       * add controls to the map view
       */

      controls: defaultControls({
        attributionOptions: ({
          collapsible: false
        })
      }),
      // this option it doesn't work at the moment, maybe need HTTP/2
      // maxTilesLoading: 30,

      /**
       * add layers to the map view
       */

      layers: [cachelayer, maplayer, copylayer],
      overlays: [overlay.overlay],
      target: 'map',
      maxTilesLoading: 32,
      view: view

    }) // end new Map
  } else {
    map = new Map({
      interactions: defaultInteractions({
        altShiftDragRotate: false,
        shiftDragZoom: false,
        mouseWheelZoom: false,
        pinchZoom: false
      }).extend([
        //  drag for overview map
        new DragRotateAndZoom(),
        // mobile function to force constrainResolution
        new PinchZoom({
          // force zooming to a integer zoom
          constrainResolution: true
        }),
        // mouseWheel function to force constrainResolution
        new MouseWheelZoom({
          constrainResolution: true
        })
      ]),

      /**
       * add controls to the map view
       */

      controls: defaultControls({
        attributionOptions: ({
          collapsible: false
        })
      }).extend([
        // add the actual scale in "m" and target a custom div
        new ScaleLine({
          units: 'metric',
          target: document.getElementById('scale_line')
        }),
        // add the pointer coordinate on the screen
        mousePositionControl,
        // add a minimap preview
        overviewMapControl
      ]),

      // this option it doesn't work at the moment, maybe need HTTP/2
      // maxTilesLoading: 30,

      /**
       * add layers to the map view
       */

      overlays: [overlay.overlay],
      target: 'map',
      maxTilesLoading: 32,
      view: view

    }) // end new Map
    map.addLayer(cachelayer)
    map.addLayer(maplayer)
    map.addLayer(copylayer)
    updateCoordsBar()
}

cachelayer.setZIndex(0)
maplayer.setZIndex(1)
copylayer.setZIndex(2)

     /**
    * Set viewpoer color to match map
    */
     setViewPortColour(viewPortTheme)

  /**
   * update the size of the map as we resize the container on load and resize
   */
  map.updateSize()

  /**
   * pointermove event listen
   */

  map.on('pointermove', function(evt) {
    if (evt.dragging) {
      return
    }
    var layers = map.getLayers()
    var hit = false
    layers.forEach(layer => {
      if(layer.className_ === 'featlayer')
      {
        var data = layer.getData(evt.pixel);
        if (data && data[3] > 0) {
          hit = true
          return
        }
      }
    })
    map.getTargetElement().style.cursor = hit ? 'pointer' : ''
  })


  /** Update the scale/coordinates bar size based in the scale width*/
  function updateCoordsBar() {
    var scaleWidth = $('.ol-scale-line-inner').width()
    var coordsObj = $('#mapcoords')
    var fullBarObj = $('#map_extras')

    fullBarObj.width(280 + scaleWidth)
    coordsObj.css('margin-left', scaleWidth + 40)
  }

  /** Set scaleBar size on resulution change */
  map.getView().on('change:resolution', (event) => {
    updateCoordsBar()
  })

  /*
   * set the visibility of the cachelayers based on zoom level and client specific
   */
  map.on('moveend', () => {

    /**
     * update accessibility table
     */
     getMapTab()
    /**
     * check it's a parkmap traffweb
     */
    if (pageconfig.appname.type === 'parkmap') {
      /**
       * barnet use a custom road map on the first couple of levels so there is no cache map
       */

/*
if (window.location.href.indexOf('barnet') > -1) {
        if (map.getView().getResolution() > 0.8 && map.getView().getResolution() < 6.5) {
          cachelayer.setVisible(true)
        }
        else {
          cachelayer.setVisible(false)
        }
      }


      else {
        if (map.getView().getResolution() > 0.8) {
          cachelayer.setVisible(true)
        }
        else {
          cachelayer.setVisible(false)
        }
      }

    */
    }

    /**
     * check it's a accsmap traffweb
     */

    else if (pageconfig.appname.type === 'accsmap') {

      if (window.location.href.indexOf('devon') !== -1 || window.location.href.indexOf('demo') !== -1 || window.location.href.indexOf('dev') !== -1 || window.location.href.indexOf('localhost') !== -1) {
        if (map.getView().getResolution() > 0.8) {
          cachelayer.setVisible(true)
        }
        else {
          cachelayer.setVisible(false)
        }
      }
      else {
        cachelayer.setVisible(true)
      }
    }

    /**
     * all other apps
     */

    else {
      if (map.getView().getResolution() > 0.8) {
        cachelayer.setVisible(true)
      }
      else {
        cachelayer.setVisible(false)
      }
    }

  /**
   * end map.on('moveend', () => {
   */
  })


  /**
   * Get Background mapping layers for theme settings
   */

  if (capXml === 'error') {
    $('#osmainthemes').append('<p>Mapping services currently unavailable.</p>')
  } else {
   let data = functions.getCacheCapabilities()
   var parser = new WMTSCapabilities();
   var result = parser.read(data);
   var layersArray = result.Contents.Layer;
   let selMainTheme = pageconfig.ovlayer
  //  let selOvTheme = pageconfig.ovlayer
   let rowid = 0
   let lang = $('#dropdownLangButton').attr('data-code')
    if (lang === '' || lang === null || typeof lang === 'undefined') {lang = 'en'}
   let layerNames = $('#themelayers').val().split(',')
   if (CookieSettings !== null && CookieSettings.length > 3) {
    selMainTheme = CookieSettings[3]

   }

   for(var i=0; i<layersArray.length; i++){
     if (i === 0 || i % 3 === 0) {
      rowid = i
      $('#osmainthemes').append('<div id="themerow_' + rowid + '" class="row p-0 m-0"></div>')
     }
     let shortTitle = layersArray[i].Title.split(' ')[1]
     let zname = layersArray[i].Title.replace('Style','').split(' ').join('')
     if (lang !== 'en') {
        shortTitle = layerNames[i]
     }

     $('#themerow_' + rowid).append('<div class="col cachelayer themerow"><button class="btn themebtn cachetheme shadow ' + (selMainTheme.indexOf(layersArray[i].Title) > 0 ? 'selectedZoomstack' : '') +'" id="cache_theme_'+ i + '" data-theme="'+ layersArray[i].Title + '"></button></div>');
     $('#cache_theme_' + i).append('<div id="main_theme_'+ i + '" class="previewZoomstack ' + zname + '" aria-hidden="true"></div>')
     $('#cache_theme_' + i).append('<span class="theme-caption">' + shortTitle + '</span>')

   }

   $('#mapthemeDiv .modal-body').css('max-height', `600px`)

    /**
     * Choose Background Mapping Theme
     */
     $('#themesbtn').on('click',function () {
      $('.themeselector').css('display','flex')
      if (functions.mobileTabletView()) {
        $('.themeselector').css('display','none')
      }
     })

    $('.themebtn').on('click',function () {
      $('.cachetheme').removeClass('selectedZoomstack')
      $(this).addClass('selectedZoomstack')
      var chosenTheme = 'Zoomstack:' + $(this).attr('data-theme') // this is the name of the theme chosen
      /**
       * Set chosen theme in cookie
       */
      Cookies.checkCookie(map, true)
         /**
        * Set viewpoer color to match map
        */
         
      setViewPortColour(chosenTheme)
      updateLayer(chosenTheme)
    })

    $('.themeshowhide').on('click',function () {
      if ($(this).hasClass('btnthemeshow')) {
        $('#osovthemes').fadeOut(150, function () {
          $('#osmainthemes').fadeIn(150);
        });
      } else {
        $('#osmainthemes').fadeOut(150, function () {
          $('#osovthemes').fadeIn(150);
        });
      }
    })
    $('.btnthemeshow').trigger('click')
  }
  /**
   * end map init
   */
}


/**
 * Set the view extents according to the selected scheme
 */

 const setSchemeExtents = (myExtents, myDefPos) => {
    // reset to full authority extents
    const setExt = pageconfig.bounds.split(',')
    const ext = [parseInt(setExt[0]), parseInt(setExt[1]), parseInt(setExt[2]), parseInt(setExt[3])]
    map.setView(
        new View({
          extent: ext,
          projection: 'EPSG:27700',
          resolution: resolutions[0],
          resolutions: resolutions
        })
      )
    //fit schemes extents to map
    map.getView().fit(myExtents, map.getSize())
    //read new extents
    let newextent = map.getView().calculateExtent(map.getSize())
    if (window.location.href.indexOf('sirgar') > -1 || window.location.href.indexOf('carmarthen')) {
        newextent = ext
    }
    //apply new map constraint
   let newDefPos = [parseInt((newextent[0] + newextent[2])/2),parseInt((newextent[1] + newextent[3])/2),(resolutions.length-1)]
    map.setView(
      new View({
        extent: newextent,
        projection: 'EPSG:27700',
        center: [parseInt(newDefPos[0]), parseInt(newDefPos[1])],
        resolution: resolutions[0],
        resolutions: resolutions
      })
    )
    // zoom to scheme
    map.getView().fit(myExtents, map.getSize())
}


/**
 * feature layer viewport tabulation for accessability standard
 * it create a list and count of the visibles features
 */

 const getMapTab = () => {
 /**
   * get the map extents and extract coords
   */

  const bcoords = map.getView().calculateExtent(map.getSize())

  /**
   * send the request with 3 params
   *  - boundaries (bccords)
   *  - the layers to query (orderl, orderp, etc)
   *  - the date in US format
  */
  let jsonString = ''

  map.getLayers().forEach(function(layer) {
    let pdate = ''
    const today = new Date()
    if (layer.className_ === 'featlayer') {
      if (layer.get('name') === 'parkmap') {
        //active date may not be initialised so:
        if ($('#activedate').val() === '') {
          pdate = `${today.getFullYear()}-${functions.leadZero(today.getMonth() + 1)}-${functions.leadZero(today.getDate())}`
        } else {
          pdate = $('#activedate').val().split('/').reverse().join('-')
        }
        jsonString += `{"type":"parkmap","bbox":"${bcoords}","layers":"${layer.getSource().getParams().LAYERS}","date":"${pdate}","selection":"${$('#featclick').val()}"},`
      } else if (layer.get('name') ===  'accsmap'){
        jsonString += `{"type":"accsmap","bbox":"${bcoords}","layers":"${layer.getSource().getParams().LAYERS}","selection":"${$('#rtcfeatclick').val().replaceAll("'", "")}","pdq":"${$('.pdq_on').attr('data-value')}", "pfilt":"${$('#pfilt').val()}","fromdate":"${$('#fromdate').val().split('/').reverse().join('-')}","todate":"${$('#todate').val().split('/').reverse().join('-')}"},`
      } else if (layer.get('name') === 'invmap') {
        jsonString += `{"type":"invmap","bbox":"${bcoords}","layers":"${layer.getSource().getParams().LAYERS}","selection":"${$('#invfeatclick').val()}"},`
      } else if (layer.get('name') === 'consult') {
        pdate = `${today.getFullYear()}-${functions.leadZero(today.getMonth() + 1)}-${functions.leadZero(today.getDate())}`
        jsonString += `{"type":"consult","bbox":"${bcoords}","layers":"${layer.getSource().getParams().LAYERS}","date":"${pdate}"},`
      } else {
        jsonString += `{"type":"${layer.get('name')}","bbox":"${bcoords}", "layers":"${layer.getSource().getParams().LAYERS}","selection":"${$('#frapsafeatclick').val()}"},`
      }
    }
  })

  // create the final json string
  jsonString = jsonString.replace(/,(?=\s*$)/, '')
  jsonString = '{"maplayers":[' + jsonString + ']}'

  /**
   * check if it's a parkamp accsmap or invmap tw
   * send the request in get method
   * send the tequest in post method if it's invmap
   */

    $.ajax({
      url: '/map-acc-tab',
      type:"POST",
      data: {
        jdata: jsonString
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
      },
      success: function (data) {
        // Write results out to #mapped_features
        let mappedFeats = JSON.parse(data)
        $('#mapped_features').empty()
        if(mappedFeats.hasOwnProperty('parkmap')){
          $('#mapped_features').append("<ul id='parkmapmapfeats'><li>ParkMap features in current map display:</li></ul>")
          $.each(mappedFeats.parkmap, function () {
            const mapitem = this
            $('<li>', {
                text: mapitem.description + ": " + mapitem.count
            }).appendTo('#parkmapmapfeats')
          })
        }
        if(mappedFeats.hasOwnProperty('invmap')){
          $('#mapped_features').append("<ul id='invmapmapfeats'><li>Inventory features in current map display:</li></ul>")
          $.each(mappedFeats.invmap, function () {
            const mapitem = this
            $('<li>', {
                text: mapitem.description + ": " + mapitem.count
            }).appendTo('#invmapmapfeats')
          })
        }
        if(mappedFeats.hasOwnProperty('accsmap')){
          $('#mapped_features').append("<ul id='accsmapmapfeats'><li>Road Traffic Accident features in current map display:</li></ul>")
          $.each(mappedFeats.accsmap, function () {
            const mapitem = this
            $('<li>', {
                id: 'accs_' + mapitem.description.toLowerCase(),
                text: mapitem.description + ": " + mapitem.count + ": " + mapitem.countT
            }).appendTo('#accsmapmapfeats')
          })
        }
        if(mappedFeats.hasOwnProperty('consult')){
          $('#mapped_features').append("<ul id='consultmapfeats'><li>Consultation features in current map display:</li></ul>")
          $.each(mappedFeats.consult, function () {
            const mapitem = this
            $('<li>', {
                text: mapitem.description + ": " + mapitem.count
            }).appendTo('#consultmapfeats')
          })
        }
        if(mappedFeats.hasOwnProperty('fra')){
          $('#mapped_features').append("<ul id='framapfeats'><li>Faults in current map display:</li></ul>")
          $.each(mappedFeats.fra, function () {
            const mapitem = this
            $('<li>', {
                text: mapitem.description + ": " + mapitem.count
            }).appendTo('#framapfeats')
          })
        }
        if(mappedFeats.hasOwnProperty('psa')){
          $('#mapped_features').append("<ul id='psamapfeats'><li>Suspensions in current map display:</li></ul>")
          $.each(mappedFeats.psa, function () {
            const mapitem = this
            $('<li>', {
                text: mapitem.description + ": " + mapitem.count
            }).appendTo('#psamapfeats')
          })
        }
      }})


  /**
   * end const ajaxVisibleLayers = (sQLayers) => {
   */

}

/**
 * Update WTMS base layers theme
 * @param {The layer o update (cache or overview)} layer
 * @param {The zoomstack theme selected} theme
 */
const updateLayer = (theme) => {
  //console.log(map.getLayers())
  /**
   * Cache Layer
   */
  let capXml = functions.getCacheCapabilities()
  let newmmLayer = getMMLayer(theme)
  let newovLayer = theme
  if (tenant == 'iom') {
    layerClass = getIomLayerCSS(theme)
    newovLayer = 'mastermap:mm-IoM_Overview'
    capXml = functions.getMMCacheCapabilities()
    newmmLayer = 'mastermap:mm-IoM'
  }
 
  var parser = new WMTSCapabilities()
  var result = parser.read(capXml)

  var options = optionsFromCapabilities(result, {
    layer: newovLayer,
    matrixSet: 'BC27700',
    format: 'image/png8',
  })

  var source = new WMTS(options)
  const setExt = pageconfig.bounds.split(',')
  const ext = [parseInt(setExt[0]), parseInt(setExt[1]), parseInt(setExt[2]), parseInt(setExt[3])]
  let minZoom = pageconfig.minzoom
  let cachelayer = new TileLayer({className: layerClass,extent: ext, source: source,minResolution: resolutions[minZoom]})
  map.getLayers().array_[0] = cachelayer
  /**
   * End Cache Layer
   */

  /**
   * Mastermap Layer
   */
  let mmcapXml = functions.getMMCacheCapabilities()
  var parser = new WMTSCapabilities()
  var mmresult = parser.read(mmcapXml)
  var mmoptions = optionsFromCapabilities(mmresult, {
    layer: newmmLayer,
    matrixSet: 'BC27700'
  })

  var mmsource = new WMTS(mmoptions)

  let maplayer = new TileLayer({className: layerClass, id: 'maplayer', extent: ext, source: mmsource, resolutions: resolutions, maxResolution: resolutions[minZoom-1], preload: Infinity})
  map.getLayers().array_[1] = maplayer
  /**
   * End Mastermap Layer
   */
  /**
   * Overview Layer
   */
  var ovsource = new WMTS(options)
  let ovlayer = new TileLayer({className: layerClass,source: ovsource})

  let overviewMapControl = new OverviewMap({
    className: 'ol-overviewmap ol-custom-overviewmap',
    layers: [ovlayer],
    view: new View({
      projection: 'EPSG:27700'
    }),
    collapseLabel: '\u00BB',
    label: '\u00AB',
    collapsed: false,
    target: document.getElementById('ovmap')
  })
  map.removeControl(map.controls.array_[5])
  map.addControl(overviewMapControl)
  /**
   * End Overview Layer
   */
  print.updatePrintLayer(theme)
}

/**
 * Convert OS Layer to IOM Styles
 *
 */

const getIomLayerCSS = (layer) => {
  switch (layer) {
    case 'Zoomstack:Zoomstack Road Style':
    case'mastermap:mm-standard':
      return 'mm-standard'
      break
    case 'Zoomstack:Zoomstack Deuteranopia Style':
    case'mastermap:mm-bw':
      return 'mm-bw'
      break
    case 'Zoomstack:Zoomstack Outdoor Style':
    case 'mastermap:mm-outdoor':
      return 'mm-outdoor'
      break
    case 'Zoomstack:Zoomstack Light Style':
    case 'mastermap:mm-light':
      return 'mm-light'
      break
    case 'Zoomstack:Zoomstack Dark Style':
    case 'mastermap:mm-dark':
      return 'mm-dark'
      break
    case 'Zoomstack:Zoomstack Tritanopia Style':
    case 'mastermap:mm-backdrop':
      return 'mm-backdrop'
      break
    default:
      return 'mm-standard'
      break
    }
}

/**
 * export:
 *  - map
 *  - resolutions array
 */

const getMap = () => map

const getResolution = () => resolutions

/**
 * EXPORT
 */

export default {
  mapInit,
  getMap,
  getResolution,
  setSchemeExtents,
  getMapTab,
  updateLayer,
  getMMLayer,
  getIomLayerCSS
}
